module.exports = __webpack_public_path__ + "static/media/mima.6d17169f.mp3";